import { Assets } from "./assets.ts"

export const Terms = () => {
  return (
    <p className="text-xs text-gray-11 mt-3">
      가입함으로써 귀하는 IYK에 따라 귀하의 데이터 처리 및 쿠키 사용에 대해 읽고 이해했으며 이에
      동의합니다{" "}
      <a href={Assets.documents.privacyPolicy} target="_blank" className="underline">
        개인정보 처리방침
      </a>
      {" & "}
      <a href={Assets.documents.termsOfService} target="_blank" className="underline">
        서비스 약관
      </a>
      .
    </p>
  )
}
